import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import * as R from "ramda"
import LeadComponent from '../components/lead.component';
import { selectLeadsQueryItems } from '../../../../../../redux/leads/selector';
import { leads } from '../../../../../../redux/leads/action';
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import { tagNames } from '../../../../../../redux/tag-names/action';
import { selectTagNamesListItems } from '../../../../../../redux/tag-names/selector';
// import { selectRelatedToTypesListItems } from '../../../../../../redux/related-to-types/selector';
// import { relatedToTypes } from '../../../../../../redux/related-to-types/action';
import { setDisplayText } from '../../../../../../common/services/tag-names.service';


const LeadsContainer = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectLeadsQueryItems)
  const tagNameListItems = useSelector(selectTagNamesListItems)
  // const  relatedToTypesListItems = useSelector(selectRelatedToTypesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const [
    selectedLead,
    setSelectedLead
  ] = useState<any>([])
  const [selectLeadAddress, setSelectLeadAddress] = useState<any>()


  const fetchLeadById = () => {
    dispatch(leads.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/leads/query`, entity: 'leads', jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedLead({ ...selectedLead, [fields[0]]: value });
    setSelectLeadAddress({ ...selectLeadAddress, [fields[0]]: value });
  }

  useEffect(
    () => {
      dispatch(tagNames.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
        entity: 'tagNames',
        jsonData: {}
      })).then(() => {
        // dispatch(relatedToTypes.list({
        //   // url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/crm/related-to-types/list`,
        //   entity:'relatedToTypes',
        //   jsonData:{}
        // })) 
        // }).then(()=>{
        if (parmas?.id > 0) {
          fetchLeadById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedLead(queryItems?.result?.items)
        setSelectLeadAddress({ PrimaryAddress: queryItems.result.items.Address })

      }
    },
    [isQuery]
  )
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(leads.resetAction({ actionType: 'update' }))
      await dispatch(leads.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/leads`,
        entity: 'leads',
        jsonData: {

          Records: [
            {
              Id: parmas?.id,
              LeadInformation: selectedLead?.LeadInformation,
              LeadAdditionalInformation: selectedLead?.LeadAdditionalInformation,
              Address: selectLeadAddress.PrimaryAddress
            }

          ]

        }
      })).then(() => {
        back()

      })

    } else {
      await dispatch(leads.resetAction({ actionType: 'create' }))
      await dispatch(leads.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/leads`,
        entity: 'leads',
        jsonData: {

          Records: [
            {
              Id: parmas?.id,
              LeadInformation: selectedLead?.LeadInformation,
              LeadAdditionalInformation: selectedLead?.LeadAdditionalInformation,
              Address: selectLeadAddress?.PrimaryAddress

            }
          ]

        }
      })).then(() => {
        back()
      })
    }


  }


  const libraryListItems = storePersist.get("library")?.current;

  const back = () => {
    navigate('/management/sales/crm/leads')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <LeadComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedLead={selectedLead}
          selectLeadAddress={selectLeadAddress}
          back={back}
          handleFormSubmit={handleFormSubmit}
          salutation={libraryListItems.Salutation}
          industryType={libraryListItems.IndustryType}
          businessType={libraryListItems.BusinessType}
          salesSource={libraryListItems.SalesSource}
          leadRating={libraryListItems.LeadRating}
          leadStatus={libraryListItems.LeadStatus}
          tagNames={setDisplayText(tagNameListItems?.result?.items)}
          //  relatedToTypes={relatedToTypesListItems?.result?.items}
          taskStatus={libraryListItems.TaskStatus}

        />
      }
    </>
  )

}

export default LeadsContainer;